import { addDays, isAfter } from "date-fns";

/** Days before nextConsentPromptAt when the in-app reminder appears. */
export const EHR_LINK_CONSENT_REMINDER_DAYS = 30;

/**
 * Convert a Firestore Timestamp / Date / null into a Date, or null.
 * @param {unknown} value
 * @returns {Date|null}
 */
export function toConsentDate(value) {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  if (value instanceof Date) return value;
  if (typeof value === "string") {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof value.seconds === "number") {
    return new Date(value.seconds * 1000);
  }
  return null;
}

/**
 * True when an active link's nextConsentPromptAt is within the reminder window
 * (due within EHR_LINK_CONSENT_REMINDER_DAYS or already past). Missing due date
 * stays quiet.
 *
 * @param {unknown} nextConsentPromptAt
 * @param {{ now?: Date }} [opts]
 * @returns {boolean}
 */
export function isEhrLinkConsentDue(nextConsentPromptAt, opts = {}) {
  const due = toConsentDate(nextConsentPromptAt);
  if (!due) return false;
  const now = opts.now instanceof Date ? opts.now : new Date();
  const windowEnd = addDays(now, EHR_LINK_CONSENT_REMINDER_DAYS);
  return !isAfter(due, windowEnd);
}
